/**
 * Footer — editorial mono-uppercase strip.
 *
 * Pure presentational. Both segments are optional strings supplied by the
 * caller; the right segment is pushed to the trailing edge.
 */

export interface FooterProps {
  left?: string;
  right?: string;
}

export function Footer({ left, right }: FooterProps) {
  return (
    <footer className="editorial-footer" role="contentinfo">
      {left && <span>{left}</span>}
      {right && <span style={{ marginLeft: 'auto' }}>{right}</span>}
    </footer>
  );
}
